module.exports = __webpack_public_path__ + "static/media/short_cymbal_01.b55be721.wav";